// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__dhl+T","form__label":"ContactForm_form__label__8W82B","form__input":"ContactForm_form__input__VGD4-","input__button":"ContactForm_input__button__+QPeE"};